import React from "react";
import Particles from "react-tsparticles";

function Particle() {
  return (
    <Particles
      id="tsparticles"
      params={{
        particles: {
          color:{
            value: "#ff6f09"
          },
          number: {
            value: 190,
            density: {
              enable: true,
              value_area: 1900,
            },
          },
          line_linked: {
            enable: true,
            opacity: 0.07,
          },
          move: {
            direction: "right",
            speed: 8.5,
          },
          size: {
            value: 1,
          },
          
          opacity: {
            anim: {
              enable: true,
              speed: 1,
              opacity_min: 0.8,
            },
          },
        },
        interactivity: {
          events: {
            onclick: {
              enable: true,
              mode: "push",
            },
          },
          modes: {
            push: {
              particles_nb: 1,
            },
          },
        },
        retina_detect: true,
      }}
    />
  );
}

export default Particle;
